import React from 'react';
import { useCustomerDetails } from '../CustomerDetails/CustomerDetailsProvider';
import AddressCard from './AddressCard';

function AddressCont({ addressData }) {
    const { addressShow, customerDetailsData } = useCustomerDetails();
    return (
        <div
            className={`flex gap-10 justify-around mb-5 transition-all duration-[600ms] ease-in-out overflow-hidden ${
                !addressShow ? 'max-h-0' : 'max-h-[260px]'
            }`}
        >
            <AddressCard
                disabled={customerDetailsData?.status !== 'active'}
                title="administrative"
                addressData={addressData?.administrative}
            />
            <AddressCard
                disabled={customerDetailsData?.status !== 'active'}
                title="billing"
                addressData={addressData?.billing}
            />
            <AddressCard
                disabled={customerDetailsData?.status !== 'active'}
                title="technical"
                addressData={addressData?.technical}
            />
        </div>
    );
}

export default AddressCont;
